module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1065.f9338921.png";